import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { SharedActionsBaseService } from '@fi-app/shared/fi-shared-services/shared-actions-base.service';
import { ITaskV2AssignedUser } from '@fi-app/task-v2/fi-task-v2';
import { FiProfileSizes, IUserProfile } from '@fi-shared/profile-icon/profile-icon.component';
import { Animations } from '@fi-shared/utils/animations';

@Component({
    selector: 'fi-task-v2-staff-assignee',
    templateUrl: './task-v2-staff-assignee.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-task-v2-staff-assignee' },
    standalone: false,
    animations: [Animations.fadeHeight()],
})
export class TaskV2StaffAssigneeComponent {
    @Input({ required: true }) assignees: ITaskV2AssignedUser[] = [];
    @Input() maxDisplayedItems = 4;
    @Input() canAddNewAssignee = true;
    @Output() addAssignee = new EventEmitter<void>();
    @Output() userDetailsClicked = new EventEmitter<number>();
    @Output() showAllChanged = new EventEmitter<boolean>();
    protected showAll = false;
    protected readonly FiProfileSizes = FiProfileSizes;

    protected get hasMoreAssignees(): boolean {
        return (this.assignees?.length || 0) > this.maxDisplayedItems;
    }

    protected get additionalAssigneesCount(): number {
        return Math.max(0, (this.assignees?.length || 0) - this.maxDisplayedItems);
    }

    protected get currentAssignees(): ITaskV2AssignedUser[] {
        if (!this.assignees) {
            return [];
        }
        return this.showAll ? this.assignees : this.getTrimmedAssignees();
    }

    constructor(private sharedActionsService: SharedActionsBaseService) {}

    protected openUserDetails(userId: number): void {
        this.userDetailsClicked.emit(userId);
    }

    protected toggleShowAllAssignees(): void {
        this.showAll = !this.showAll;
        this.showAllChanged.emit(this.showAll);
    }

    protected openAddStaffMembersAssigneeDialog(): void {
        this.addAssignee.emit();
    }

    protected openBusinessUnitDetails(businessUnitId: number): void {
        this.sharedActionsService.openUnitViewPopup(businessUnitId);
    }

    private getTrimmedAssignees(): ITaskV2AssignedUser[] {
        if (!this.assignees || this.assignees.length === 0) {
            return [];
        }
        return this.assignees.slice(0, this.maxDisplayedItems);
    }
}
